import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from '../settings/SettingsWrapper.vue';
import AccountsList from './AccountsList.vue';
import AccountShow from './AccountShow.vue';
import TemplatesList from './templates/TemplatesList.vue';
import TemplateForm from './templates/TemplateForm.vue';

// Cross-account SuperAdmin section (see Sidebar.vue "SuperAdmin" item, below Settings).
// Nested under accounts/:accountId purely to satisfy the existing account-membership route
// guard (routeHelpers.js#validateLoggedInRoutes) — the pages themselves ignore accountId and
// talk to non-account-scoped API endpoints (api/superAdmin/*.js). Real gating is
// meta.superAdminOnly (see routeHelpers.js) on the frontend, and
// Api::V1::SuperAdmin::BaseController#ensure_super_admin! on the backend.
const meta = { superAdminOnly: true };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/super-admin'),
      component: SettingsWrapper,
      children: [
        { path: '', redirect: 'accounts' },
        {
          path: 'accounts',
          name: 'super_admin_accounts_list',
          meta,
          component: AccountsList,
        },
        {
          path: 'accounts/:superAdminAccountId',
          name: 'super_admin_account_show',
          meta,
          component: AccountShow,
        },
        {
          path: 'templates',
          name: 'super_admin_templates_list',
          meta,
          component: TemplatesList,
        },
        {
          path: 'templates/new',
          name: 'super_admin_template_new',
          meta,
          component: TemplateForm,
        },
        {
          path: 'templates/:templateId/edit',
          name: 'super_admin_template_edit',
          meta,
          component: TemplateForm,
        },
      ],
    },
  ],
};
